// @flow
import React from "react";
import Dropzone from "react-dropzone";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toastr } from "react-redux-toastr";
import styles from "./attachments.scss";
import {
  removeAttachmentfile,
  setUploadFilesSelected
} from "./attachmentsRedux/attachmentActionCreator";

import { attachmentFileSizeInMB } from "../../../services/helpers";

const cancelAttachmentUrl = require("../../../assets/images/cancel.svg");
const uploadedFileImage = require("../../../assets/images/file_upload.svg");
const uploadAttachmentIcon = require("../../../assets/images/outline-cloud_upload-24px.svg");

type Props = {
  setUploadFilesSelected: Function,
  removeAttachmentfile: Function,
  attachmentState: Object,
  heading?: string,
  dropzoneWrapperStyle?: string
};

class Attachments extends React.Component<Props> {
  onRemoveAttachmentFile(file) {
    const removeIndex = this.props.attachmentState.uploadFilesSelected
      .map(f => f.name)
      .indexOf(file.name);
    const remainingFiles = this.props.attachmentState.uploadFilesSelected;
    remainingFiles.splice(removeIndex, 1);
    this.props.removeAttachmentfile(remainingFiles);
  }

  updateFilesToUpload(files: Array) {
    this.props.setUploadFilesSelected(files);
  }

  displayFileSize(size: number) {
    if (size <= 1024) {
      return `${size} bytes`;
    } else if (size > 1024 && size < 1000000) {
      return `${parseFloat(Math.round(size / 1024)).toFixed(2)} KB`;
    }

    return `${parseFloat(Math.round(size / 1000000)).toFixed(2)} MB`;
  }

  handleFileUpload(event: Object) {
    Array.from(event.target.files).forEach(file =>
      this.props.setUploadFilesSelected(file)
    );
  }

  fileRejectionToastr() {
    const toastrOptions = {
      timeOut: 4000,
      component: (
        <div>
          <h2>Caution!</h2>
          <h3>
            {`  File of size above ${attachmentFileSizeInMB}MB is not accepted. Please select files of smaller size.`}
          </h3>
        </div>
      )
    };

    toastr.error("", toastrOptions);
  }

  render() {
    return (
      <div className={`${styles.attachmentModalWrapper}`}>
        <div className={`${styles.headingAttachmentText}`}>
          {this.props.heading || "Upload files"}
        </div>
        <div className="">
          <div className={`${styles.attachmentWrapper} flex-100`}>
            <div className="j-center">
              <Dropzone
                className={`${styles.dropzoneWrapper} ${this.props.dropzoneWrapperStyle}`}
                onDrop={files => {
                  this.updateFilesToUpload(files);
                }}
                multiple={true}
                disablePreview={false}
                maxSize={attachmentFileSizeInMB * 1048576}
                onDropRejected={() => {
                  this.fileRejectionToastr();
                }}
              >
                <div className={styles.uploadAttachmentIconWrapper}>
                  <img src={uploadAttachmentIcon} alt="Icn" />
                </div>
                <div className={`${styles.initialAttachmentText}`}>
                  Click to browse or drag and drop to upload
                </div>
              </Dropzone>
              <div className={`${styles.maxFileSizeAttachmentText}`}>
                Max size {attachmentFileSizeInMB} MB for each file
              </div>
              {
                // <input
                //   type="file"
                //   id="files"
                //   multiple
                //   className={`${styles.fileInput}`}
                //   name="Browse"
                //   onChange={event => this.handleFileUpload(event)}
                // />
              }
            </div>
            <div className={styles.attachmentFilesCombined}>
              {" "}
              {this.props.attachmentState.uploadFilesSelected &&
                this.props.attachmentState.uploadFilesSelected.map(f => (
                  <div
                    key={f.name}
                    className={`${styles.uploadedFileWrapper} l-row flex-100`}
                  >
                    <div className="flex-10 half-opac">
                      <img
                        src={uploadedFileImage}
                        alt=""
                        className={styles.commentIcn}
                      />
                    </div>
                    <div className="flex-80 half-opac">
                      <div className={styles.attachmentFileName}>{f.name}</div>
                      <div className={styles.attachmentFileSize}>
                        {this.displayFileSize(f.size)}
                      </div>
                    </div>
                    <div className="flex-10 half-opac">
                      <button
                        key={f.name}
                        className={styles.cancelButton}
                        onClick={() => this.onRemoveAttachmentFile(f)}
                      >
                        <img
                          className={styles.cancelAttachmentIcn}
                          src={cancelAttachmentUrl}
                          alt="Loading..."
                        />
                      </button>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  attachmentState: state.attachmentState
});

const mapDispatchToProps = dispatch => ({
  setUploadFilesSelected: bindActionCreators(setUploadFilesSelected, dispatch),
  removeAttachmentfile: bindActionCreators(removeAttachmentfile, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Attachments);



// WEBPACK FOOTER //
// ./app/components/commons/attachments/attachments.js